export enum CheckoutPaths {
	CONFIRMATION = '/OrderShippingBillingConfirmationView',
	PAYPAL = '/SingleShipmentOrderSummaryView',
	SINGLEPAGE = '/SinglePageCheckout'
}
